import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { IDT } from '@ff-os/pdp-shared-redux/IDT';
import { AspectRatio } from '@ff-os/shared-react/components/aspect-ratio/AspectRatio';
import { Image } from '@ff-os/shared-react/components/image/Image';
import { useExternalFromPriceRender } from '@ff-os/shared-react/hooks/useExternalFromPriceRender';
import classNames from 'classnames';
import { VariantOption } from '../../VariantOption';
import styles from './VariantRadio.module.scss';

export const VariantRadio = ({
    iconUrl, label, name,
    price, priceRequest,
    selected, onClick
}: Props) => {

    const { t } = useTranslation();

    const className = classNames(styles.default, {
        [styles.selected]: selected
    });

    return (
        <div className={className} onClick={onClick}>
            <AspectRatio>
                {price && <PriceLabel>{price}</PriceLabel>}
                {priceRequest && <RequestPriceLabel priceRequest={priceRequest} />}

                <Image className={styles.image} src={iconUrl} alt={t(name.key, name.args)} />
            </AspectRatio>

            <div className={styles.heading}>
                <h4 className={styles.title}>
                    {t(name.key, name.args)}
                </h4>

                {label && (
                    <p className={styles.subtitle}>
                        {t(label.key, label.args)}
                    </p>
                )}
            </div>

            <div className={styles.mark}>
                <div className={styles.inner} />
            </div>
        </div>
    );
};

const RequestPriceLabel = ({ priceRequest }: { priceRequest: IDT.FromPriceRequest }) => {

    const { t } = useTranslation();
    const { destinationRef, plainText } = useExternalFromPriceRender(priceRequest);

    return (
        <span ref={destinationRef}>
            {plainText && <PriceLabel>{plainText} {t('photo_prints.price_apiece')}</PriceLabel>}
        </span>
    );
};

const PriceLabel = ({ children }: { children: ReactNode }) => (
    <span className={styles.price}>
        {children}
    </span>
);

type Props = VariantOption & {
    selected: boolean;
    onClick: () => void;
};